"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswersRendererFactory = void 0;
const isUnlimitedRepetition_1 = __importDefault(require("@opsbase/lib-form/helpers/isUnlimitedRepetition"));
const updateActiveQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/updateActiveQuestions"));
const Answer_1 = __importDefault(require("@opsbase/web-answer/Answer"));
const AnswerMeta_1 = __importDefault(require("@opsbase/web-answer/AnswerMeta"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    root: {
        flexWrap: 'wrap',
        maxWidth: '100%',
        width: '100%',
        position: 'unset',
    },
});
const AnswersRendererFactory = (viewField, idx, pdf = false) => (op) => {
    const { questionNodeId } = viewField;
    const form = op.getParsedForm();
    (0, updateActiveQuestions_1.default)(form);
    const questionNode = form.questions[questionNodeId];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const myCss = (0, web_css_1.default)(makeMyClasses);
    // Unlimited repetition Questions
    if ((0, isUnlimitedRepetition_1.default)(form, questionNodeId)) {
        const parent = form.questions[questionNode.repetitionAncestorId];
        return (react_1.default.createElement(Vertical_1.default, { gutter: true }, (0, range_1.default)(questionNode.totalRepetitions).map(i => {
            const nodeId = parent.questionId + '_' + i + '_' + questionNode.questionId;
            const thisNode = form.questions[nodeId];
            let content = (react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(Text_1.default, null, '-')));
            if (thisNode === null || thisNode === void 0 ? void 0 : thisNode.enabled) {
                content = (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Pane_1.default, { grow: true },
                        react_1.default.createElement(AnswerMeta_1.default, { form: form, isScoreEnabled: op.isScoreEnabled, questionNodeId: nodeId, pdf: pdf }),
                        react_1.default.createElement(Answer_1.default, { form: form, questionNodeId: nodeId }))));
            }
            return (react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, key: 'rep' + i }, content));
        })));
    }
    else if (!(questionNode === null || questionNode === void 0 ? void 0 : questionNode.enabled))
        return null;
    // All other question types
    else {
        return (react_1.default.createElement(Pane_1.default, { classes: { root: myCss.root } },
            react_1.default.createElement(AnswerMeta_1.default, { form: form, isScoreEnabled: op.isScoreEnabled, questionNodeId: questionNodeId, pdf: pdf }),
            react_1.default.createElement(Answer_1.default, { form: form, questionNodeId: questionNodeId })));
    }
};
exports.AnswersRendererFactory = AnswersRendererFactory;
exports.default = exports.AnswersRendererFactory;
